import { SvgIcon } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const HowToInstallIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 36 36" fill="none" >
            <rect x="8" y="3" width="20" height="30" rx="3" stroke="#16191E" strokeWidth="2" />
            <line x1="18" y1="16" x2="18" y2="27" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M21 24L18 27L15 24" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="16" y1="7" x2="20" y2="7" stroke="black" strokeWidth="2" strokeLinecap="round" />
        </SvgIcon>
  )
}
